import {Component, EventEmitter, OnChanges, Output, SimpleChanges, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  DxActionSheetModule,
  DxButtonModule,
  DxPopoverModule,
  DxPopupModule,
  DxToolbarModule,
  DxTooltipModule
} from "devextreme-angular";
import {DxButtonTypes} from "devextreme-angular/ui/button";
import {UtilsService} from "../../../services/utils.service";
import { FormDto, FormTypes} from "../../../models/ortak.dtos";
import {DkFormPopupComponent} from "../../form-popup/dk-form-popup.component";
import {DkListHelpFormComponent} from "../../help-desk/dk-list-help-form/dk-list-help-form.component";
import {FormDetayHistoryDto, GetLastXAction_Request} from "@dabnet-kamu/libs/gen/models/manuel-models";
import {OrtakService} from "@dabnet-kamu/libs/ui/shared/services/ortak.service";
import {LogFormIslemComponent} from "../../log-form-islem/log-form-islem.component";
import {EkranHataKaydi, ekranHataKaydi} from "../../../services/ekran-hata-kaydi"; // DKM-5193 Cedric

@Component({
  selector: 'dk-list-footer',
  standalone: true,
  imports: [CommonModule, DxToolbarModule, DxButtonModule, DxActionSheetModule, DxTooltipModule,
    DxPopoverModule, DxPopupModule, DkFormPopupComponent, DkListHelpFormComponent, LogFormIslemComponent],
  templateUrl: './list-footer.component.html',
  styleUrls: ['./list-footer.component.scss'],
})

export class ListFooterComponent implements OnChanges {
  @Input() formCode: string = '';
  @Input() formMetaData: FormDto = new FormDto();
  @Input() formType: FormTypes=FormTypes.ListForm;
  @Input() listAction: string = '';
  @Input() errorResponse: string[];
  @Input() isShowLastActions: boolean = false;
  /** Grid'de o an seçili satır. Verilirse KayitTarih/KayitKullaniciKod/DegisTarih/
   *  DegisKullaniciKod alanları doğrudan bu objeden okunup gösterilir (isim çözümü
   *  yapılmaz - satır seçimi hızlı değiştiği için ekstra servis çağrısı atılmıyor). */
  @Input() recordData: any;
  @Output() lastActionSelectedData = new EventEmitter<any>();
  showPopover = false;
  showLastActionsPopup = false
  lastActionsData: FormDetayHistoryDto[] = [];
  actionSheetTarget = '';
  actionSheetVisible = false;
  actionSheetDataSource: any[] = [];

  toastMessageButtonOptions: DxButtonTypes.Properties = {
    icon: 'belloutline',
    stylingMode: 'outlined',
    hint: 'Hata Mesajları',
    onClick: () => {
      // DKM-5193 Cedric: eski hâli — yalnız ekran servisinin tek errorResponse alanını gösteriyordu
      // this.showLastErr(this.errorResponse)
      this.hataMesajlariniGoster();
    },
  };

  detailsLayoutButtonOptions: DxButtonTypes.Properties = {
    icon: 'detailslayout',
    stylingMode: 'outlined',
    disabled: true,
  };


  helpButtonOptions: DxButtonTypes.Properties = {
    icon: 'comment',
    stylingMode: 'outlined',
    hint:'Yardım',
    onClick: () => {
      this.showHelpPopUp()

    },
  };
  lastActionsButtonOptions = {
    icon: "clock",
    stylingMode: 'outlined',
    text: 'Son İşlemler',
    hint: "Son İşlemler",
    elementAttr: {
      id: 'btnLastActionsTarget' // Popover'ın hedefleyeceği yeni ID
    },
    onClick: (e:any) => {
      this.showLastActionsPopUp(e)
    }
  };
  helpPopupVisible=false
  logFormIslemPopupVisible = false;

  logFormIslemButtonOptions: DxButtonTypes.Properties = {
    icon: 'group',
    stylingMode: 'outlined',
    hint: 'Form İşlem Logları',
    onClick: () => {
      this.logFormIslemPopupVisible = true;
    },
  };

  constructor(private utilsService: UtilsService,
              private ortakService:OrtakService
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    // dtokgoz 17.10: seçili kayıt hata kaydına (destek talebi) girsin — kayıt hata anında okunur
    if (changes['recordData'] || !this.kayitBildirildi) {
      this.kayitBildirildi = true;
      ekranHataKaydi.kayitKaynagiBildir(this, () => ({ form: this.formCode, kayit: this.recordData }));
    }
  }

  private kayitBildirildi = false;

  ngOnDestroy() {
    ekranHataKaydi.kayitKaynagiBirak(this); // dtokgoz 17.10
  }

  get auditInfo(): { kayitKullanici?: string | number; kayitTarih?: Date; degisKullanici?: string | number; degisTarih?: Date } | null {
    if (!this.recordData?.Kod) {
      return null;
    }
    if (!this.recordData.KayitTarih && !this.recordData.KayitKullaniciKod && !this.recordData.DegisTarih && !this.recordData.DegisKullaniciKod) {
      return null;
    }
    return {
      // Grid'de isim kolonu (KayitKullaniciAd/DegisKullaniciAd) zaten geliyorsa
      // ekstra servis çağrısı atmadan onu göster, yoksa kod'a düş.
      kayitKullanici: this.recordData.KayitKullaniciAd || this.recordData.KayitKullaniciKod,
      kayitTarih: this.recordData.KayitTarih,
      degisKullanici: this.recordData.DegisKullaniciAd || this.recordData.DegisKullaniciKod,
      degisTarih: this.recordData.DegisTarih,
    };
  }

  showLastErr(errorRes: any) {
    let err = errorRes?.message ? JSON.parse(errorRes?.message) : errorRes;
    if (
      err === null ||
      err === undefined ||
      (typeof err !== 'object' && err.length === 0) ||
      (typeof err === 'object' && Object.keys(err).length === 0) ||
      err === 0 ||
      err === ''
    ) {
      this.utilsService.showSuccess(
        'Hata Mesajı Bulunmuyor',
        '',
        'toast-bottom-right'
      );
    } else {
      this.utilsService.showError(err, '', 'toast-bottom-right');
    }
  }
  /**
   * DKM-5193 Cedric: "Hata Mesajları" — bu sekmede alınan son 10 hata (ekran hata kaydı). Kayıt yoksa eski davranış:
   * errorResponse aynen showLastErr ile gösterilir (o gösterim yeni kayıt açmaz).
   */
  hataMesajlariniGoster() {
    let kayitlar: EkranHataKaydi[] = [];
    try {
      kayitlar = ekranHataKaydi.liste(ekranHataKaydi.aktifSekme(), 10);
    } catch {
      kayitlar = [];
    }
    if (!kayitlar.length) {
      ekranHataKaydi.kaydetmeden(() => this.showLastErr(this.errorResponse));
      return;
    }
    const ad = this.formCode ? this.getFormName(this.formCode) : '';
    this.utilsService.showHataListesi(
      `Bu ekranda alınan son hatalar (${kayitlar.length})${ad ? ' — ' + ad : ''}`,
      ekranHataKaydi.listeHtml(kayitlar)
    );
  }

  getFormName(page:any):string{
    return page.slice(page.lastIndexOf("/") + 1)
  }

  closeHelpForm($event: any) {
    this.helpPopupVisible = false
  }

  private showHelpPopUp() {
    this.helpPopupVisible = true
  }

  private mapLastActionsToSheetItems(history: FormDetayHistoryDto[]) {
    // 1. Tarihçe verilerini Action Sheet öğelerine dönüştürün
    const historyItems = history.map(item => ({
      text: item.aciklama + '(' + item.cagriAdet + ')',
      data: item // Orijinal veriyi saklayın
    }));

    // 2. Listenin en sonuna "Kapat" öğesini 'danger' tipiyle ekleyin
    const closeItem = {
      text: 'Kapat',
      data: 'close', // Kapatma işlemini tetiklemek için kullanılacak özel veri
      type: 'danger'  // 👈 Buraya DevExtreme'in tipini ekledik
    };

    // 3. İki listeyi birleştirip geri döndürün
    return [...historyItems, closeItem];
  }
  private showLastActionsPopUp($event:any) {

    this.ortakService.GetLastXAction_Request(new GetLastXAction_Request({
      formAd: this.getFormName(this.formCode),
    })).then(res => {
      if(res.response.result){
        this.actionSheetTarget = $event.element
        this.actionSheetDataSource = this.mapLastActionsToSheetItems(res.response.history);
        this.actionSheetVisible = true; // Action Sheet'i aç
      }
    })
  }

  handleActionSheetSelection(e: any) {
    // Seçilen öğenin orijinal verisine erişim (data özelliği)
    const selectedItem = e.itemData.data;
    if (e.itemData.data === 'close') {
      this.actionSheetVisible = false; // Action Sheet'i kapat
      return; // Fonksiyondan çık
    }
    if (selectedItem) {
      this.lastActionSelectedData.emit(selectedItem);
    }
    this.actionSheetVisible = false; // Seçim sonrası kapat
  }

}
